// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"form_wrapper--26GrK","form":"form--2F_l4","title":"title--fmEd_","submit_btn":"submit_btn--G7LkF"};